import React from "react";
import { connect } from "react-redux";
import "../Forms/css/register.css";
import axios from "axios";

const token = localStorage.getItem('authToken');

class AddPackages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addDeals:'',
            title: '',
            description: '',
            purchasePrice: '',
            salesPrice: '',
            startDate: '',
            endDate: '',
            submissionStatus: null,
        };
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        const jsonData = {
            addDeals:this.state.addDeals,
            title: this.state.title,
            description: this.state.description,
            price: parseFloat(this.state.purchasePrice),
            startDate: this.state.startDate,
            endDate: this.state.endDate,
        };

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            };

            const response = await axios.post("https://brand.aasmo.in/api/admin/package", jsonData, config);

            console.log('Response:', response);

            if (response && response.status === 201) {
                this.setState({ submissionStatus: 'success' });
                console.log('Form submitted successfully');
                setTimeout(() => {
                    window.location.href = "/list-packages";
                }, 2000);
            } else {
                console.log('Unexpected response:', response);
            }

        } catch (error) {
            console.error('Error submitting form:', error);

            if (error.response) {
                const { status, data } = error.response;
                if (status === 400) {
                    console.error('Bad request error:', data);
                } else if (status === 401) {
                    console.error('Unauthorized error, please log in again.');
                } else {
                    console.error('Error response:', error.response);
                }
            } else {
                console.error('Network or other error:', error);
            }
        }
    };

    render() {
        const { title, description, purchasePrice, salesPrice, addDeals,startDate, endDate, submissionStatus } = this.state;
        return (
            <div className="col-md-12">
                <form onSubmit={this.handleSubmit}>
                    <div className="card">
                        <div className="header">
                            <h2>Add Packages</h2>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="title"
                                            value={title}
                                            onChange={this.handleChange}
                                            placeholder="Package Title"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea
                                            className="form-control"
                                            name="description"
                                            value={description}
                                            onChange={this.handleChange}
                                            placeholder="Package Description"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label> Price</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            className="form-control"
                                            name="purchasePrice"
                                            value={purchasePrice}
                                            onChange={this.handleChange}
                                            placeholder="Price"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Add Deals</label>
                                        <input
                                            type="number"
                                            min={0}
                                            className="form-control"
                                            name="addDeals"
                                            value={addDeals}
                                            onChange={this.handleChange}
                                            placeholder="Package Add Deals"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Start Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="startDate"
                                            value={startDate}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>End Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="endDate"
                                            value={endDate}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    {submissionStatus === 'success' && (
                                        <div className="alert alert-success" role="alert">
                                            Form submitted successfully!
                                        </div>
                                    )}
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(AddPackages);
